<template>
  <div
    class="w-full flex items-center justify-center max-h-screen overflow-hidden"
  >
    <div
      class="flex min-w-96 flex-col items-center justify-between min-h-screen max-h-screen overflow-y-auto py-16"
    >
      <router-link :to="{ name: 'home' }">
        <img src="@/assets/svgs/logo.svg" alt="" />
      </router-link>

      <!-- Step 1: Request OTP -->
      <div class="w-full" v-if="step === 1">
        <div class="mb-16">
          <h1 class="font-black text-4xl text-center font-roboto mb-4 text-black">
            Forgot Password
          </h1>
          <p class="font-sans text-center text-base">
            Enter your email and we'll send you a reset OTP
          </p>
        </div>
        <div class="mb-6">
          <label class="block text-sm mb-4">
            Email address
            <input
              class="block border text-sm border-grey w-full rounded-lg py-4 px-5 mt-2 border-opacity-50"
              type="email"
              placeholder="Enter your email address"
              v-model="email"
            />
          </label>
          <p v-if="error" class="text-red-500 my-2">{{ error }}</p>
          <p v-if="successMsg" class="text-green-600 my-2">{{ successMsg }}</p>
        </div>
        <button-with-loader
          buttonText="Send OTP"
          :loading="loading"
          :onClick="requestOTP"
        />
        <p class="text-center mt-6 text-sm">
          <router-link :to="{ name: 'login' }" class="underline">Back to Login</router-link>
        </p>
      </div>

      <!-- Step 2: Reset with OTP -->
      <div class="w-full" v-if="step === 2">
        <div class="mb-10">
          <h1 class="font-black text-4xl text-center font-roboto mb-4 text-black">
            Reset Password
          </h1>
          <p class="font-sans text-center text-base">
            Enter the OTP sent to <span class="font-semibold">{{ email }}</span> and your new password
          </p>
        </div>
        <div class="mb-6">
          <label class="block text-sm mb-4">
            OTP Code
            <input
              class="block border text-sm border-grey w-full rounded-lg py-4 px-5 mt-2 border-opacity-50"
              type="text"
              placeholder="Enter OTP"
              v-model="otp"
            />
          </label>
          <label class="block text-sm mb-4">
            New Password
            <input
              class="block border text-sm border-grey w-full rounded-lg py-4 px-5 mt-2 border-opacity-50"
              type="password"
              placeholder="Enter new password"
              v-model="newPassword"
            />
          </label>
          <label class="block text-sm mb-4">
            Confirm New Password
            <input
              class="block border text-sm border-grey w-full rounded-lg py-4 px-5 mt-2 border-opacity-50"
              type="password"
              placeholder="Confirm new password"
              v-model="confirmPassword"
            />
          </label>
          <p v-if="error" class="text-red-500 my-2">{{ error }}</p>
          <p v-if="successMsg" class="text-green-600 my-2">{{ successMsg }}</p>
        </div>
        <button-with-loader
          buttonText="Reset Password"
          :loading="loading"
          :onClick="resetPassword"
        />
        <p class="text-center mt-4 text-sm">
          <button @click="step = 1; error = ''; successMsg = ''" class="underline">
            Re-send OTP
          </button>
        </p>
      </div>

      <!-- Step 3: Success -->
      <div class="w-full text-center" v-if="step === 3">
        <div class="mb-10">
          <h1 class="font-black text-4xl font-roboto mb-4 text-black">
            Password Reset!
          </h1>
          <p class="font-sans text-base mb-8">
            Your password has been reset successfully. You can now log in.
          </p>
          <router-link
            :to="{ name: 'login' }"
            class="bg-realBlack text-white font-medium py-3 px-8 rounded-lg cursor-pointer"
          >
            Go to Login
          </router-link>
        </div>
      </div>

      <div></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ButtonWithLoader from "@/components/ButtonWithLoader.vue";
export default {
  name: "ForgotPassword",
  components: { ButtonWithLoader },
  data() {
    return {
      step: 1,
      loading: false,
      email: "",
      otp: "",
      newPassword: "",
      confirmPassword: "",
      error: "",
      successMsg: "",
    };
  },
  methods: {
    async requestOTP() {
      this.error = "";
      this.successMsg = "";
      if (!this.email) {
        this.error = "Please enter your email address.";
        return;
      }
      this.loading = true;
      try {
        const response = await this.$store.dispatch("authRequest", {
          path: "/admin/auth/request-password-reset",
          data: { email: this.email },
        });
        this.successMsg = response.data.message || "OTP sent! Check your email.";
        this.step = 2;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          this.error = err.response.data.message || "Failed to send OTP.";
        } else {
          this.error = "An error occurred. Please try again.";
        }
      } finally {
        this.loading = false;
      }
    },
    async resetPassword() {
      this.error = "";
      this.successMsg = "";
      if (!this.otp || !this.newPassword || !this.confirmPassword) {
        this.error = "Please fill in all fields.";
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.error = "Passwords do not match.";
        return;
      }
      this.loading = true;
      try {
        await this.$store.dispatch("authRequest", {
          path: "/admin/auth/reset-password",
          data: { email: this.email, otp: this.otp, newPassword: this.newPassword },
        });
        this.step = 3;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          this.error = err.response.data.message || "Failed to reset password.";
        } else {
          this.error = "An error occurred. Please try again.";
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
